import React, { useContext, useEffect, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-date-picker";
import { Helmet } from "react-helmet-async";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Store } from "../Store";
import FiliskaPagination from "../components/FiliskaPagination";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import StockInputEditorModal from "../components/StockInputEditorModal";
import useAxios from "../hooks/useAxios";
import {
  getError,
  getUnitLabel,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "FETCH_REQUEST":
      return { ...state, loading: true };
    case "FETCH_SUCCESS":
      return {
        ...state,
        stockInputs: action.payload.stockInputs,
        totalPrice: action.payload.totalPrice,
        totalCachePrice: action.payload.totalCachePrice,
        totalPosPrice: action.payload.totalPosPrice,
        page: action.payload.page,
        pages: action.payload.pages,
        loading: false,
      };
    case "FETCH_FAIL":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default function StockInputListScreen(props) {
  const axios = useAxios();
  const [
    {
      error,
      loading,
      stockInputs,
      totalPrice,
      pages,
      totalCachePrice,
      totalPosPrice,
    },
    dispatch,
  ] = useReducer(reducer, {
    loading: false,
    error: "",
    stockInputs: [],
    totalPrice: 0,
    totalCachePrice: 0,
    totalPosPrice: 0,
  });

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const navigate = useNavigate();
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const [page, setPage] = useState(sp.get("page") || 1);
  const [query, setQuery] = useState(null);
  const [productId, setProductId] = useState("");

  const { state } = useContext(Store);
  const { userInfo } = state;

  const [features, setFeatures] = useState([]);

  const [unit, setUnit] = useState("ADET-1");
  const [name, setName] = useState("");
  const [showEditor, setShowEditor] = useState(false);
  const [stock, setStock] = useState({});
  const [operationSuccessfull, setOperationSuccessfull] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [queryByDesc, setQueryByDesc] = useState("");
  const {
    setShowStockEditor,
    setStockInputSuccessfull,
    stockFromExpense,
    expenseMod,
  } = props;

  useEffect(() => {
    setShowEditor(props.showEditor);
  }, [props]);

  useEffect(() => {
    if (setShowStockEditor && !showEditor) {
      setShowStockEditor(!!showEditor);
    }
  }, [showEditor]);

  useEffect(() => {
    if (stockFromExpense) {
      const fetchProductData = async () => {
        try {
          if (stockFromExpense.product) {
            const { data: productData } = await axios.get(
              `/api/products/${stockFromExpense.product._id}`
            );

            editStockHandler({ ...stockFromExpense, product: productData });
          } else {
            editStockHandler(stockFromExpense);
          }
        } catch (err) {
          toast.error(getError(err));
        }
      };
      if (stockFromExpense.product) {
        fetchProductData();
        editStockHandler(stockFromExpense);
      } else {
        editStockHandler(stockFromExpense);
      }
    }
  }, [stockFromExpense]);

  const editStockHandler = (stock) => {
    setStock(stock);
    if (stock.product) {
      setProductId(stock.product._id);
      setName(stock.product.name);
      setUnit(stock.product.unit);
      setIsUpdate(true);
    } else {
      setProductId(null);
      setName("");
      setUnit("ADET-1");
      setIsUpdate(false);
    }
    setShowEditor(true);
  };
  const deleteStockHandler = async (stockId) => {
    if (window.confirm("Silmek istediginize emin misiniz?")) {
      try {
        await axios.delete(`/api/stock/inputStock/${stockId}`);

        toast.success("Stok silindi!");
        if (!expenseMod) {
          fetchData();
        }
      } catch (error) {
        toast.error(getError(error));
      }
    }
  };

  const fetchData = async () => {
    dispatch({ type: "FETCH_REQUEST" });

    try {
      if (query) {
        const { data } = await axios.get(
          `/api/stock/admin/stockInputs/search?page=${page}&pageSize=4&byDesc=${queryByDesc}&year1=${query.getFullYear()}&month1=${query.getMonth()}&day1=${query.getDate()}&year2=${query.getFullYear()}&month2=${query.getMonth()}&day2=${
            query.getDate() + 1
          }`
        );

        dispatch({ type: "FETCH_SUCCESS", payload: data });
      } else {
        const { data } = await axios.get(
          `/api/stock/admin/stockInputs?page=${page}&pageSize=4&byDesc=${queryByDesc}`
        );
        dispatch({ type: "FETCH_SUCCESS", payload: data });
      }
    } catch (err) {
      dispatch({ type: "FETCH_FAIL", payload: err });
      toast.error(getError(err));
    }
  };

  useEffect(() => {
    if (operationSuccessfull && !expenseMod) {
      fetchData();
    }
    if (operationSuccessfull) {
      fetchData();
      setOperationSuccessfull(false);
      setProductId(null);
      setFeatures(null);
      setName("");
      setUnit("ADET-1");
      setQuery(null);
      if (setStockInputSuccessfull) {
        setStockInputSuccessfull(true);
      }
    }
  }, [operationSuccessfull]);

  useEffect(() => {
    if (!expenseMod) {
      fetchData();
    }
  }, [page, userInfo, query, queryByDesc]);

  return (
    <div className="small-container">
      <Helmet>
        <title>Stok Girişleri</title>
      </Helmet>

      {!isTabletOrMobile && (
        <>
          <h1 className="my-3 text-muted">Stok Girişleri</h1>
          <hr className="hr"></hr>
        </>
      )}
      <div
        className="mb-3"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <div>
          <InputGroup>
            <Button
              onClick={() => {
                if (query) {
                  let date = new Date(query);
                  date.setDate(date.getDate() - 1);
                  setQuery(date);
                  navigate(`/admin/stockInputs?page=1`);
                } else {
                  let date = new Date();
                  setQuery(date);
                  navigate(`/admin/stockInputs?page=1`);
                }
              }}
            >
              <i className="fas fa-caret-left"></i>
            </Button>
            <DatePicker
              value={query}
              locale="tr-TR"
              closeCalendar={false}
              onChange={(d) => {
                setQuery(d);
                navigate(`/admin/stockInputs?page=1`);
              }}
              className="text-center flex-auto"
            ></DatePicker>
            <Button
              onClick={() => {
                if (query) {
                  let date = new Date(query);
                  date.setDate(date.getDate() + 1);

                  if (Date.now() < date) {
                    return false;
                  }

                  setQuery(date);
                  navigate(`/admin/stockInputs?page=1`);
                } else {
                  let date = new Date();

                  if (Date.now() < date) {
                    return false;
                  }

                  setQuery(date);
                  navigate(`/admin/stockInputs?page=1`);
                }
              }}
            >
              <i className="fas fa-caret-right"></i>
            </Button>
          </InputGroup>
        </div>
        <div>
          <Button
            type="button"
            onClick={() => {
              setShowEditor(true);
              editStockHandler({
                price: "",
                amount: "",
                feature: "",
                stockId: "",
                paymentType: "CACHE",
              });
            }}
            className={"text-primary border-primary"}
            variant="light"
          >
            <i className="fas fa-plus"></i>
            {!isTabletOrMobile && <>&nbsp; Yeni Stok Girişi</>}
          </Button>
        </div>
      </div>
      {error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>
                  {false && (
                    <InputGroup>
                      <FormControl
                        type="text"
                        value={queryByDesc}
                        onChange={(e) => {
                          setQueryByDesc(e.target.value);
                        }}
                        placeholder="Ara..."
                        aria-label="Ara"
                      ></FormControl>
                      {queryByDesc && (
                        <Button
                          variant="light"
                          className="border-danger text-danger"
                          onClick={() => setQueryByDesc("")}
                        >
                          Temizle
                        </Button>
                      )}
                    </InputGroup>
                  )}
                  {loading && <LoadingBox></LoadingBox>}
                </th>
                <th>Fiyat</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {stockInputs.map((stock) => (
                <tr key={stock._id}>
                  <td>
                    {stock.amount + " " + getUnitLabel(stock.unit)}
                    {stock.feature ? " " + stock.feature : ""}
                    &nbsp;{stock.product.name}
                    <div>
                      <span className="text-muted">
                        {new Date(stock.createdAt)
                          .toLocaleString("tr-TR")
                          .substring(0, 16)}
                      </span>
                    </div>
                  </td>
                  <td>
                    {turkishCurrencyFormatterNoPrecision(stock.price)}{" "}
                    <div>
                      <span className="text-muted">
                        {stock.paymentType === "CACHE" ? "Nakit" : "POS"}
                      </span>
                    </div>
                  </td>
                  <td>
                    <Button
                      className="text-success p-1"
                      variant="light"
                      onClick={() => editStockHandler(stock)}
                    >
                      <i className="fas fa-edit"></i>
                    </Button>
                    &nbsp;
                    <Button
                      variant="light"
                      className="text-danger p-1"
                      onClick={() => deleteStockHandler(stock._id)}
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>
                  <div>
                    <FiliskaPagination
                      leftRightSize={2}
                      page={page}
                      pages={pages}
                      onFirst={() => setPage(1)}
                      onLast={() => setPage(pages)}
                      onNext={() => {
                        if (page < pages) {
                          setPage(page + 1);
                        }
                      }}
                      onPrev={() => {
                        if (page > 1) {
                          setPage(page - 1);
                        }
                      }}
                      onItemNext={(p) => setPage(p)}
                      onItemPrev={(p) => setPage(p)}
                    ></FiliskaPagination>
                  </div>

                  <table className="table">
                    <tbody>
                      <tr>
                        <td>
                          <span>Toplam</span>
                        </td>
                        <td className="text-end">
                          {turkishCurrencyFormatterNoPrecision(totalPrice)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>Nakit</span>
                        </td>
                        <td className="text-end">
                          {turkishCurrencyFormatterNoPrecision(totalCachePrice)}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span>POS:</span>
                        </td>
                        <td className="text-end">
                          {turkishCurrencyFormatterNoPrecision(totalPosPrice)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tfoot>
          </table>

          <StockInputEditorModal
            isUpdate={isUpdate}
            setOperationSuccessfull={setOperationSuccessfull}
            showEditor={showEditor}
            setShowEditor={setShowEditor}
            features={features}
            stock={stock}
            productId={productId}
            setProductId={setProductId}
            setName={setName}
            setFeatures={setFeatures}
            setUnit={setUnit}
            userInfo={userInfo}
            name={name}
            unit={unit}
          ></StockInputEditorModal>
        </>
      )}
    </div>
  );
}
